<template>
  <b-modal
    :id="id"
    ok-title="บันทึก"
    ok-variant="success"
    cancel-title="ยกเลิก"
    title="แก้ไขข้อมูล"
    size="lg"
    @ok="submit"
    @hide="onClose"
    @cancel="$emit('cancel')"
  >
    <template v-if="participant">
      <table class="table table-borderless mb-3">
        <tr>
          <th class="text-center mr-3" width="200">รหัสนักศึกษา :</th>
          <td class="align-left">
            <b-form-input v-model="participant.studentId" />
          </td>
        </tr>
        <tr class="mb-5">
          <th class="text-center" width="200">ชื่อ - นามสกุล :</th>
          <td class="align-middle">
            <b-form-input v-model="participant.name" />
          </td>
        </tr>
        <tr>
          <th class="text-center" width="200">ประเภท :</th>
          <td class="align-middle">
            <b-form-group class="mb-0">
              <b-form-input
                value="ผู้เข้าร่วมโครงการ (P)"
                readonly
              />
            </b-form-group>
          </td>
        </tr>
      </table>
    </template>
  </b-modal>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    id: { type: String, required: true },
    index: { type: Number, required: false, default: () => null },
    participant: { type: Object, required: false, default: () => null }
  },
  watch: {
    participant (participantObject) {
      if (participantObject) {
        this.$bvModal.show(this.id)
      }
    }
  },
  methods: {
    onClose (event) {
      this.$nextTick(() => { this.$bvModal.hide(this.id) })
      this.$emit('close')
    },
    async submit () {
      this.setParticipantType()
      await this.$apollo.mutate({
        mutation: gql`mutation($id: ID!, $index: Int!, $input: IndividualParticipantInput!) { projectEditIndividualParticipant(id: $id, index: $index, input: $input) { id } }`,
        variables: { id: this.$route.params.id, index: this.index, input: { fullName: this.participant.name, studentId: this.participant.studentId, type: this.participant.type } }
      })
      this.$bvToast.toast('บันทึกการเปลี่ยนแปลงสำเร็จ', {
        title: 'แจ้งเตือน',
        variant: 'success',
        solid: true
      })
    },
    setParticipantType () {
      this.participant.type = 'p'
    }
  }
}
</script>
